<template>
	<div class="filter-list">
        <div :class="['list-header', getAnySelectedClass]">
            <h4 v-if="subheader != ''" :class="['subheading', 'list-title']">
                {{ subheader }}  
            </h4>
            <v-btn
                v-if="doCloseAll"
                icon
                class="remove-applied-filters"
                @click="removeAppliedFilters">
                <v-icon color="white" size="30">close</v-icon>
            </v-btn>
        </div>

        <div v-if="items.length===0" class="filter-list-loading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else class="filter-list-loaded">
            <filter-list-item
                v-for="item in items"
                :class="['val-'+item.value]"
                :key="generateUniqueHash(item)"
                :item="item"
                :parentId="id"
                :set-classes="itemClasses"
                :id="makeItemId(item)"
                :type="type"
                :isActive="isSelected(item)"
                :anySelected="getAnySelected()"
                @click.native="handleItemClick(item)"/>
        </div>

	</div>
</template>


<script>
    import { mapState, mapGetters, mapWatchers } from 'vuex'

	import FilterListItem from '@/components/ui/_global/Filter_List_Item.vue'

	export default {
		name: 'filter-list',

		components:{
			'filter-list-item' : FilterListItem
		},

		props: {
			items: {
				type: Array,
				required: true
			},
			selected: {
				type: Boolean,
				default: false
			},
			dispatchOnSelect: {
				type: Function,
				required: false
			},
            id: {
                type: String,
                default: '',
                required: false
            },
            subheader: {
                type: String,
                default: '',
                required: false
            },
            doCloseAll: {
                type: Boolean,
                default: false,
                required: false
            },
            type: {
                type: String,
                default: '',
                required: false
            },
            itemClasses: {
                type: String,
                default: '',
                required: false
            },

		},

		data:() => ({
            idToFilterOn: [], //id to filter map -
            keyChange:1.0 //used to force update
		}),

        mounted() {
            //key = id, value = filterOn (filterOn from store js)
            //JOBS
            if (this.type==='absences') {
                //TIME OFF & ABSENCES
                this.idToFilterOn['absences_staff'] = 'staff'
                this.idToFilterOn['absences_status'] = 'status'
                this.idToFilterOn['absences_type'] = 'type'
                this.idToFilterOn['absences_users_staff'] = 'userStaff'
                this.idToFilterOn['absences_users_freelance'] = 'userFreelance'

            } else if (this.type==='users') {
                //USERS
                this.idToFilterOn['users_job_role'] = 'role'
                this.idToFilterOn['users_job_department'] = 'department'
                this.idToFilterOn['users_department_role'] = 'departmentRole'
                this.idToFilterOn['users_type'] = 'employeeType'
                this.idToFilterOn['users_status'] = 'state'
                this.idToFilterOn['users_access'] = 'access'

            } else {
                //JOBS
                this.idToFilterOn['status'] = 'status'
                this.idToFilterOn['progress'] = 'progress'
                this.idToFilterOn['progress_note'] = 'progressNote'
                this.idToFilterOn['type'] = 'type'
                this.idToFilterOn['department'] = 'department'
                this.idToFilterOn['due_by'] = 'due'
                this.idToFilterOn['creative_round'] = 'creativeRound'

                this.idToFilterOn['project_managers'] = 'userProjectManager'
                this.idToFilterOn['print_project_managers'] = 'userPrintProjectManager'
                this.idToFilterOn['premedia_project_managers'] = 'userPremediaProjectManager'
                this.idToFilterOn['art_directors'] = 'userArtDirector'
                this.idToFilterOn['creatives'] = 'userCreative'
                this.idToFilterOn['requestors'] = 'userRequestor'
            }

            this.keyChange++ //refresh

        },

        watch: {
            appliedFilters: {
                handler: function (val, oldVal) {
                    //Fix for now
                    //There are timing issues on the appliedFilters
                    //It gets drawn before the data is ready, then not updated
                    this.$nextTick(() => {
                        this.keyChange++
                    })
                    this.keyChange = this.keyChange+1
                    return val;
                },
                deep:true
            }
        },

		computed: {
		    ...mapState({
                jobsFilterToggler(state) {
                    var ret
                    if (this.type==='absences') {
                        ret = state.calendarItems.filterToggler
                    } else if (this.type==='users') {
                        ret = state.users.filterToggler
                    } else {
                        ret = state.jobs.filterToggler
                    }
                    return ret
                },
                appliedFilters(state) {
                    var ret
                    if (this.type==='absences') {
                        ret = state.calendarItems.appliedFilters
                    } else if (this.type==='users') {
                        ret = state.users.appliedFilters
                    } else {
                        ret = state.jobs.appliedFilters
                    }
                    return ret
                }
            }),

            getColor() { return this.active ? 'blue lighten-4' : 'blue lighten-4'},

            selectedItems() {
                let retVal = []
                if (this.keyChange>0) {
                    var tid = this.idToFilterOn[this.id]
                    if (tid !== undefined) {
                        for (var i in this.appliedFilters) {
                            var key = this.appliedFilters[i]
                            if (tid === key.filterOn) {
                                retVal.push(key)
                            }
                        }
                    }
                }
                return retVal
            },

            getAnySelectedClass() {
                if (this.keyChange>0) {
                    if (this.selectedItems.length>0) {
                        return 'is-selected'
                    }
                }
                return ''
            },

		},

		methods: {
            getFilterCount(t) {
                var ret
                if (this.type === "absences") {
                    ret = this.$store.getters.getAbsencesFilterCount(t)
                } else {
                    ret = this.$store.getters.getFilterCount(t)
                }
                return ret
            },

			handleItemClick(item) {
                // First add or remove it form the selected list
				if (this.isSelected(item)) {
					this.selectedItems.splice(this.selectedItems.findIndex(x => x.value === item.value), 1)
				} else {
					this.selectedItems.push(item)
				}

				// Then dispatch
				if (this.dispatchOnSelect) {
					this.dispatchOnSelect(item)
				}

				// And emit
				this.$emit('filter-applied', item)

                //SET FILTER_TOGGLER
                if (this.type === "absences") {
                    this.$store.dispatch('VUEX_CALENDAR_ITEMS_SET_FILTER_TOGGLER', {value: "manual"})
                } else {
                    this.$store.dispatch('VUEX_JOBS_CLEAR_TEXT_FILTER_SEARCH')
                    this.$store.dispatch('VUEX_JOBS_SET_FILTER_TOGGLER', { value: "manual"})
                }

			},

            removeAppliedFilters() {
                // loop through items and click it closed
                if (this.items) {
                    for (var i = 0; i < this.items.length; i++) {
                        var item = this.items[i]
                        if (this.isSelected(item)) {
                            this.handleItemClick(item)
                        }
                    }
                }
            },

            isSelected(item) {
                if (this.keyChange>0) {
                    let idx = this.selectedItems.findIndex(x => x.value === item.value);
                    if (idx > -1) {
                        return true
                    }
                }
                return false
			},

            getAnySelected() {
                if (this.keyChange>0) {
                    if (this.selectedItems.length>0) {
                        return true
                    }
                }
                return false
            },

			makeItemId(item) {
				return this.id + '__' + item.value
			},

			shouldBeClickable(item) {
				return String(parseInt(this.getFilterCount({ id: this.makeItemId(item) })) !== 0)
			},
		}
	}
</script>